import { mobile, NotMobile, tablet } from "components/templates/Breakpoints";
import { StandardSection } from "components/templates/StandardSection";
import { Vimeo } from "@services";
import { FC, useState } from "react";
import styled, { ThemeContext } from "styled-components";
import { color } from "@styles";
import { PlayButton } from "components/atoms/PlayButton";
import {
  getVerticalPadding,
  VerticalPadding,
  VerticalPaddingWrapper,
  verticalPadSideProp,
} from "../utils/verticalPadding";
import { types, Image } from "react-bricks/frontend";

interface VideoStripProps {
  background?: types.IColor;
  vimeoId: string;
  altText: string;
  paddingVertical?: VerticalPadding;
}

export const VideoStrip: types.Brick<VideoStripProps> = ({
  vimeoId,
  background,
  altText,
  paddingVertical,
}) => {
  const [isVideoOpen, setIsVideoOpen] = useState(false);

  return (
    <VerticalPaddingWrapper
      paddingVertical={paddingVertical}
      backgroundColor={background?.color || color.S310}
    >
      {isVideoOpen && (
        <VimeoWrapper>
          <Vimeo
            vimeoId={vimeoId}
            isOpen={isVideoOpen}
            onClose={() => {
              setIsVideoOpen(false);
            }}
          />
        </VimeoWrapper>
      )}
      <StandardSection pt="0" pb="0">
        <ImageContainer>
          <Image propName="videoImg" alt={altText} maxWidth={1120} />
          <PlayButtonContainer onClick={() => setIsVideoOpen(true)}>
            <PlayButton />
          </PlayButtonContainer>
        </ImageContainer>
      </StandardSection>
    </VerticalPaddingWrapper>
  );
};

VideoStrip.schema = {
  name: "video-strip",
  label: "Video Strip",
  category: "Video Components",
  previewImageUrl: "/static/bricks/video-strip.png",
  repeaterItems: [],
  getDefaultProps: () => ({
    background: { color: color.white },
    vimeoId: "861578371",
    videoImg: {
      src: "/static/img/VideoPlayer/HunterDesigns.jpg",
      placeholderSrc: "",
      alt: "Video preview",
      width: 1120,
      height: 622,
    },
    altText: "The Head of People at Hunter Design Associates",
  }),
  sideEditProps: [
    verticalPadSideProp,
    {
      name: "background",
      label: "Background Color",
      type: types.SideEditPropType.Select,
      shouldRefreshStyles: true,
      selectOptions: {
        display: types.OptionsDisplay.Color,
        options: [
          { value: { color: color.B210 }, label: "Gray" },
          { value: { color: color.white }, label: "White" },
        ],
      },
    },
    {
      name: "videoImg",
      label: "Video preview image",
      type: types.SideEditPropType.Image,
    },
    {
      name: "vimeoId",
      label: "Vimeo ID",
      type: types.SideEditPropType.Text,
      shouldRefreshStyles: true,
    },
    {
      name: "altText",
      label: "Alt Text",
      type: types.SideEditPropType.Text,
      shouldRefreshStyles: true,
    },
  ],
};

const PlayButtonContainer = styled.div`
  display: flex;
  position: absolute;
  top: 42%;
  left: 43%;
  cursor: pointer;
  max-width: 11%;
`;

export const VimeoWrapper = styled.div`
  position: absolute;
  top: 10.625rem;
  left: 3.4375rem;
`;

export const ImageContainer = styled.div`
  position: relative;
  display: flex;
  justify-content: center;
  width: 100%;

  img {
    width: 100%;
    height: auto;
    max-width: 100%;
  }

  ${NotMobile} {
    svg {
      transition: 300ms ease-in-out;
    }

    &:hover {
      svg {
        transform: translateY(-4rem) scale(1.2);
      }
    }
  }
`;
